"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _reactIs = require("react-is");
var _FormControl = require("../FormControl");
var _formControlState = _interopRequireDefault(require("../FormControl/formControlState"));
var _utils = require("../InputBase/utils");
var _Menu = _interopRequireDefault(require("../Menu"));
var _tss = require("../styles/tss");
var _useControlled = _interopRequireDefault(require("../utilities/useControlled"));
var _useForkRef = _interopRequireDefault(require("../utilities/useForkRef"));
var _SelectIcon = _interopRequireDefault(require("./SelectIcon"));
const _excluded = ["aria-label", "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "displayEmpty", "IconComponent", "inputRef", "isSsrOnly", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "required", "SelectDisplayProps", "tabIndex", "type", "value"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function areEqualValues(a, b) {
  if (typeof b === 'object' && b !== null) {
    return a === b;
  }
  return String(a) === String(b);
}
function isEmpty(display) {
  return display == null || typeof display === 'string' && !display.trim();
}
/**
 * @ignore - internal component.
 */
const SelectInput = /*#__PURE__*/React.forwardRef(function SelectInput(props, ref) {
  const {
      'aria-label': ariaLabel,
      autoFocus,
      autoWidth,
      children,
      classes = {},
      className,
      defaultValue,
      displayEmpty,
      IconComponent,
      inputRef: inputRefProp,
      isSsrOnly,
      labelId,
      MenuProps,
      multiple,
      name,
      onBlur,
      onChange,
      onClose,
      onFocus,
      onOpen,
      open: openProp,
      readOnly,
      renderValue,
      required,
      SelectDisplayProps = {},
      tabIndex: tabIndexProp,
      // catching `type` from Input which makes no sense for SelectInput
      type,
      value: valueProp
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    cx
  } = (0, _tss.useEmptyStyles)();
  const [value, setValue] = (0, _useControlled.default)({
    controlled: valueProp,
    default: defaultValue,
    name: 'SelectInput'
  });
  const inputRef = React.useRef(null);
  const [displayNode, setDisplayNode] = React.useState(null);
  const {
    current: isOpenControlled
  } = React.useRef(openProp != null);
  const [menuMinWidthState, setMenuMinWidthState] = React.useState();
  const [openState, setOpenState] = React.useState(false);
  const handleRef = (0, _useForkRef.default)(ref, inputRefProp);
  const dsFormControl = (0, _FormControl.useFormControl)();
  const fcs = (0, _formControlState.default)({
    props,
    dsFormControl,
    states: ['disabled', 'error', 'focused']
  });
  React.useImperativeHandle(handleRef, () => ({
    focus: () => {
      displayNode.focus();
    },
    node: inputRef.current,
    value
  }), [displayNode, value]);
  React.useEffect(() => {
    if (autoFocus && displayNode && displayNode !== null) {
      displayNode.focus();
    }
  }, [autoFocus, displayNode]);
  const update = (open, event) => {
    if (open) {
      if (onOpen) {
        onOpen(event);
      }
    } else if (onClose) {
      onClose(event);
    }
    if (!isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
      setOpenState(open);
    }
  };
  const handleMouseDown = event => {
    // Ignore everything but left-click
    if (event.button !== 0) {
      return;
    }
    event.preventDefault();
    displayNode.focus();
    update(true, event);
  };
  const handleClose = event => {
    update(false, event);
  };
  const handleItemClick = child => event => {
    if (!multiple) {
      update(false, event);
    }
    let newValue;
    if (multiple) {
      newValue = Array.isArray(value) ? value.slice() : [];
      const itemIndex = value.indexOf(child.props.value);
      if (itemIndex === -1) {
        newValue.push(child.props.value);
      } else {
        newValue.splice(itemIndex, 1);
      }
    } else {
      newValue = child.props.value;
    }
    if (value === newValue) {
      return;
    }
    setValue(newValue);
    if (onChange) {
      event.persist();
      Object.defineProperty(event, 'target', {
        writable: true,
        value: {
          value: newValue,
          name
        }
      });
      onChange(event, child);
    }
  };
  const handleKeyDown = event => {
    if (!readOnly) {
      const validKeys = [' ', 'ArrowUp', 'ArrowDown', 'Enter'];
      if (validKeys.indexOf(event.key) !== -1) {
        event.preventDefault();
        update(true, event);
      }
    }
  };
  const open = (displayNode !== null || isSsrOnly) && (isOpenControlled ? openProp : openState);
  const handleBlur = event => {
    if (!open && onBlur) {
      event.persist();
      Object.defineProperty(event, 'target', {
        writable: true,
        value: {
          value,
          name
        }
      });
      onBlur(event);
    }
  };
  delete other['aria-invalid'];
  let display;
  let displaySingle;
  const displayMultiple = [];
  let computeDisplay = false;
  let foundMatch = false;

  // No need to display any value if the field is empty.
  if ((0, _utils.isFilled)({
    value
  }) || displayEmpty) {
    if (renderValue) {
      display = renderValue(value);
    } else {
      computeDisplay = true;
    }
  }
  const items = React.Children.map(children, child => {
    if (! /*#__PURE__*/React.isValidElement(child)) {
      return null;
    }
    if (process.env.NODE_ENV !== 'production') {
      if ((0, _reactIs.isFragment)(child)) {
        console.error(["Design System: The Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }
    let selected;
    if (multiple) {
      if (!Array.isArray(value)) {
        throw new Error('Design System: The `value` prop must be an array ' + 'when using the `Select` component with `multiple`.');
      }
      selected = value.some(v => areEqualValues(v, child.props.value));
      if (selected && computeDisplay) {
        displayMultiple.push(child.props.children);
      }
    } else {
      selected = areEqualValues(value, child.props.value);
      if (selected && computeDisplay) {
        displaySingle = child.props.children;
      }
    }
    if (selected) {
      foundMatch = true;
    }
    return /*#__PURE__*/React.cloneElement(child, {
      // @ts-ignore
      'aria-selected': selected ? 'true' : undefined,
      onClick: handleItemClick(child),
      onKeyUp: event => {
        if (event.key === ' ') {
          event.preventDefault();
        }
        if (child.props.onKeyUp) {
          child.props.onKeyUp(event);
        }
      },
      role: 'option',
      selected,
      value: undefined,
      // The value is most likely not a valid HTML attribute.
      'data-value': child.props.value // Instead, we provide it as a data attribute.
    });
  });
  if (process.env.NODE_ENV !== 'production') {
    React.useEffect(() => {
      if (!foundMatch && !multiple && value !== '') {
        const values = React.Children.toArray(children).map(child => child.props.value);
        console.warn([`Design System: You have provided an out-of-range value \`${value}\` for the select ${name ? `(name="${name}") ` : ''}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${values.filter(x => x != null).map(x => `\`${x}\``).join(', ') || '""'}.`].join('\n'));
      }
    }, [foundMatch, children, multiple, name, value]);
  }
  if (computeDisplay) {
    display = multiple ? displayMultiple.join(', ') : displaySingle;
  }

  // Avoid performing a layout computation in the render method.
  let menuMinWidth = menuMinWidthState;
  if (!autoWidth && isOpenControlled && displayNode) {
    menuMinWidth = displayNode.clientWidth;
  }
  let tabIndex;
  if (typeof tabIndexProp !== 'undefined') {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = fcs.disabled ? undefined : 0;
  }
  const buttonId = SelectDisplayProps.id || (name ? `ds-component-select-${name}` : undefined);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
    className: cx(classes.root, classes.select, classes.selectMenu, {
      [classes.disabled]: fcs.disabled,
      [classes.error]: fcs.error,
      [classes.focused]: fcs.focused
    }, className),
    ref: setDisplayNode,
    tabIndex: tabIndex,
    role: "button",
    "aria-disabled": fcs.disabled ? 'true' : undefined,
    "aria-expanded": open ? 'true' : undefined,
    "aria-haspopup": "listbox",
    "aria-label": ariaLabel,
    "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
    onKeyDown: handleKeyDown,
    onMouseDown: fcs.disabled || readOnly ? undefined : handleMouseDown,
    onBlur: handleBlur,
    onFocus: onFocus
  }, SelectDisplayProps, {
    // The id is required for proper a11y
    id: buttonId
  }), isEmpty(display) ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  }) : display), /*#__PURE__*/React.createElement("input", (0, _extends2.default)({
    value: Array.isArray(value) ? value.join(',') : value,
    name: name,
    ref: inputRef,
    type: "hidden"
    // eslint-disable-next-line jsx-a11y/no-autofocus -- TODO: [fix-jsx-a11y]
    ,
    autoFocus: autoFocus
  }, other)), IconComponent && /*#__PURE__*/React.createElement(_SelectIcon.default, {
    classes: classes,
    IconComponent: IconComponent,
    open: open
  }), /*#__PURE__*/React.createElement(_Menu.default, (0, _extends2.default)({
    id: `menu-${name || ''}`,
    anchorEl: displayNode,
    open: !!open,
    onClose: handleClose
  }, MenuProps, {
    MenuListProps: _objectSpread({
      'aria-labelledby': labelId,
      role: 'listbox',
      disableListWrap: true
    }, MenuProps?.MenuListProps),
    PaperProps: _objectSpread(_objectSpread({}, MenuProps?.PaperProps), {}, {
      style: _objectSpread({
        minWidth: menuMinWidth
      }, MenuProps?.PaperProps?.style)
    })
  }), items));
});
var _default = exports.default = SelectInput;